import React from 'react';

import InfoIcon from 'icons/info.svg';
import { useTranslation } from 'react-i18next';

export default function ProcessingNotice() {
  const { t: i18nTAttachments } = useTranslation('common', {
    keyPrefix: 'attachments',
  });

  return (
    <div
      className='tw-flex tw-rounded-lg tw-border-0 tw-bg-cyan-025 tw-p-3 tw-text-cyan-800'
      data-element-name='attachment-processing-notice'
    >
      <div className='tw-mr-3 tw-h-5'>
        <InfoIcon
          className='[&_path]:tw-fill-cyan-800'
          height={20}
          width={20}
        />
      </div>
      <p className='tw-m-0'>{i18nTAttachments('stillProcessing')}</p>
    </div>
  );
}
